import { EpaChemicalUpdateRequest } from '../request-models/epa-chemical-update-request.model';
import { omitUndefined } from './wire-value-utils';

/**
 * Builds the PUT /admin/epa-chemicals/:id body: only `sdsUrl`, `adminNotes` and `isHidden`, and only the ones
 * that are set. The hub rejects any other key with a 400. `null` (clear the field) is kept.
 */
export function toEpaChemicalRequest(fields: EpaChemicalUpdateRequest): EpaChemicalUpdateRequest {
  return omitUndefined<EpaChemicalUpdateRequest>({
    sdsUrl: fields.sdsUrl,
    adminNotes: fields.adminNotes,
    isHidden: fields.isHidden,
  });
}
